/* istanbul ignore file - better tested visually */
import { ComponentProps, forwardRef, ReactNode, SyntheticEvent, useState } from 'react';

export type ImageProps = ComponentProps<'img'> & {
  fallback?: ReactNode;
  alt: string;
};

export const Image = forwardRef<HTMLImageElement, ImageProps>(({ fallback, onError, src = '', alt, ...rest }, ref) => {
  const [imageFailed, setImageFailed] = useState(false);

  function handleError(event: SyntheticEvent<HTMLImageElement, Event>) {
    setImageFailed(true);
    onError?.(event);
  }

  if (imageFailed) {
    return <>{fallback}</>;
  }

  return <img ref={ref} src={src} alt={alt} onError={handleError} {...rest} />;
});
